import { requireGuest, SignInPage } from "@/features/auth";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/(auth)/sign-in")({
  validateSearch: searchSchema,
  beforeLoad: requireGuest,
  component: SignInPage,
});
